import axios from 'axios';

const config = {
    baseURL: 'http://api.htclosings.com/api/v1/'
};

// axios.defaults.withCredentials = true;

export default axios.create(config);
